//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ObjectFunc = require('@/tbs/util/ObjectFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
         console.log('@handleCreationComplete')
        if (this._bridge.isCreate()) {
            this.fetchCityRegion()
            this.handleCreateSceneCreationComplete()
        }
        else if (this._bridge.isEdit()) {
            this.fetchCityRegion()
            this.creationComplete()
        }
    },
    handleCreateSceneCreationComplete: function() {
        console.log('@handleCreateSceneCreationComplete')
        const self = this
        const name = self._bridge.getRouteQuery('matchName')
        if (name) {
            self.target().match.organizationId = self._bridge.getRouteQuery('organizationId')
            self.target().match.brandId = self._bridge.getRouteQuery('matchBrandId')
            self.target().match.brandName = self._bridge.getRouteQuery('matchBrandName')
            self.target().match.brandLogoUrl = self._bridge.getRouteQuery('matchBrandLogoUrl')
            self.target().match.name = name
            self.target().match.logoUrl = self._bridge.getRouteQuery('matchBrandLogoUrl')
            self.target().match.areaId = self._bridge.getRouteQuery('matchBrandAreaId')
            self.target().match.area = self._bridge.getRouteQuery('matchBrandArea')
            self.target().match.year = self._bridge.getRouteQuery('year')
            self.target().match.session = self._bridge.getRouteQuery('session')
            console.log('self.target().match', self.target().match)
        }
    },
    handleCreateService: function(e) {
        if (e.data.result == true) {
            console.log('handleCreateService', e.data.payload.data.id)
            // go to the match detail/manage page
            this._bridge.goToScene('OrgManageMatch', {id: e.data.payload.data.id})
        }
    },
    handleDataLoaded: function() {
        console.log('@MatchMediator.handleDataLoaded')
        const self = this
        const brandId = self._bridge.getRouteQuery('matchBrandId')
        console.log('@brandId', brandId)
        if (brandId) {
            // clear the match name since new brand selected
            self.target().match.name = ''
            self.target().match.brandId = brandId
            self.target().match.brandName = self._bridge.getRouteQuery('matchBrandName')
            self.target().match.brandLogoUrl = self._bridge.getRouteQuery('matchBrandLogoUrl')
            self.target().match.year = (new Date).getFullYear().toString()
            let sessionMax = Number(self._bridge.getRouteQuery('matchSessionMax'))
            sessionMax = sessionMax ? sessionMax + 1 : 1
            self.target().match.session = sessionMax.toString()
            console.log('@brandId.year.session', (new Date).getFullYear().toString(), sessionMax.toString())
        }    
    },
    /*handleRouteBack: function() {
        console.log('handleRouteBack', this._bridge.getRouteName(), this._bridge.getRouteParam())
        if (this._bridge.getRouteName() == 'OrgEditMatch') {
            this._bridge.goToScene('OrgManageMatch', this._bridge.getRouteParam())
        }
        else {
            this._bridge.back()
        }
    },*/
    handleRemoveService: function(e) {
        if (e.data.result == true) {
            console.log('@handleRemoveService', this.target().match.organizationId)
            this._bridge.goToScene('OrgManageOrganization', {id: this.target().match.organizationId})
        }
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchMediator, BaseMediator);

module.exports = tbs_controller_MatchMediator